import React from 'react'
import TableFacturasEmitidas from './TableFacturasEmitidas'
import FiltrosSuscripcion from './FiltrosSuscripcion'

const CardFacturasEmitidas = () => {
  return (
    <div className='card w-10'>
      <h4 className='h4-titles'>Historial de suscripción</h4>
      <div className='separador'></div>
      <FiltrosSuscripcion />
      <TableFacturasEmitidas />
    </div>
  )
}

export default CardFacturasEmitidas
